export default "__VITE_ASSET__ee988d76__"